/**
 * mwApp.acls module <br>
 * Work with acls
 *
 * @namespace mwApp/acls
 */

/**
 * ConfigRoutes
 * Configurates module routes
 *
 * @class ConfigRoutes
 * @memberof mwApp/acls
 * @see mwApp/acls
 *
 * @ngdoc config
 * @name mwApp/acls.config:ConfigRoutes
 */
/* @ngInject */
export default function ConfigRoutes ($stateProvider) {
  $stateProvider

    /**
     * abstract state for /acllist
     */
    .state('app.acllist', {
      abstract: true,
      url: '/geoblocking',
      template: '<ui-view/>'
    })

    /**
     * controller {@link mwApp/aclList.controller:AclListCtrl}
     * @name /acllist
     * @memberof mwApp/acls.config:ConfigRoutes
     */
    .state('app.acllist.list', {
      url: '',
      templateUrl: 'components/acls/views/aclList.html',
      controller: 'AclListCtrl as vm',
      label: 'Geo Blocking',
      access: 'viewGeoBlocking',
      resolve: {
        forNetwork: /* @ngInject */ function ($location, Network) {
          const id = $location.$$search.networkId
          return +id
            ? Network.load({ id })
            : null
        }
      }
    })

    /**
     * abstract state for /:id
     */
    .state('app.acllist.acl', {
      abstract: true,
      url: '/:id',
      template: '<ui-view/>',
      resolve: {
        acl: /* @ngInject */ function ($transition$, Acl) {
          var { id } = $transition$.params()
          return +id
            ? Acl.load({ id })
            : new Acl()
        },
        inapp: /* @ngInject */ function (InappSettings) {
          return InappSettings.lazyLoad()
            .catch(() => ({})) // suppress error in case of failed loading
        }
      }
    })

    /**
     * controller {@link mwApp/addAcl.controller:AddAclCtrl}
     * @name /geoblocking/:id
     * @memberof mwApp/acls.config:ConfigRoutes
     */
    .state('app.acllist.acl.edit', {
      url: '',
      templateUrl: 'components/acls/views/addAcl.html',
      controller: 'AddAclCtrl as vm',
      label: '{{::id | addOrEdit}} Geo Blocking',
      access: ':id (+) ! IF createGeoBlocking ELSE editGeoBlocking'
    })
}
